enum AppEnv {
  PRODUCTION = 'production',
  STAGING = 'staging',
  STAGING2 = 'staging2',
}

export default AppEnv;
